export default "__VITE_ASSET__BaUo0doX__"